export default "__VITE_ASSET__8NxWW5ZwMVAAMbbINJdeCA__"